require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/es6.promise.js");

require("core-js/modules/es6.object.assign.js");

require("core-js/modules/es7.promise.finally.js");